// Maison Fermoir, 18/10/2026 (Mika) — Compte les ajouts au panier dans Clarity.
// Les « événements intelligents » de Clarity ne voient pas l'ajout du thème (1 session en 7 jours quand GA4 en
// comptait 30). Le thème publie `cart:updated` sur le document après chaque ajout RÉUSSI, avec sa source
// (`assets/product-form.js`, `quick-add.js`, `cross-sell.js`) ; les autres sources (tiroir, code, cadeau, minuteur)
// ne sont pas des ajouts. On le transmet à Clarity sous le nom `ajout_panier`, et `upgrade` garde l'enregistrement
// de la session même quand Clarity échantillonne.
(function () {
  var AJOUTS = { 'product-form': 1, 'quick-add': 1, 'cross-sell': 1 };
  document.addEventListener('cart:updated', function (e) {
    var data = (e.detail && e.detail.data) || {};
    if (!AJOUTS[data.source] || data.didError || typeof window.clarity !== 'function') return;
    window.clarity('event', 'ajout_panier');
    window.clarity('set', 'ajout_panier_source', data.source);
    window.clarity('upgrade', 'ajout_panier');
  });
})();
